import React from 'react';
import s from './Detail.css';

class Detail extends React.Component {
  render() {
    const { item } = this.props;
    if (typeof item.id === 'undefined') { return null; }  // DEPRECATED:  not needed..

    return (
      <article className={s.wrapper} key={item.id}>

        <div>
          <h3>{item.line} {item.gender} - {item.id}</h3>
          <h1>{item.name}</h1>

          <ul>{item.colors.map(c => <li key={c}>{c}</li>)}</ul>
        </div>

        <div>
          <pre>{JSON.stringify(item.cpbl, null, 2)}</pre>
        </div>

        <div>
          <p>{item.description}</p>

          <button>6 Images</button>
          <button>Video</button>
        </div>

        <div>
          {['features','fabric','sizes','padding','instruction'].map((topic, i) => {
            return (
              <section key={i}>
                <h3>{topic}</h3>
                <ul>

                </ul>
              </section>
            );
          })}
        </div>
      </article>
    );
  }
}

Detail.propTypes = {
  item: React.PropTypes.object.isRequired,
};

export default Detail;




/** WEBPACK FOOTER **
 ** ./components/Products/Detail.js
 **/